<template>
  <v-flex xs12 row>
    <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            
            <autocomplete
              v-model="filter.period"
              label="Time Period"
              search-key="type"
              :items="$options.periods"
            />
            
            <date-picker 
              v-if="filter.period === 'monthly'" 
              v-model="filter.year_month" 
              :min="minDateFrom" 
              :max="maxDate" 
              label="Year & Month" 
              class="mr-3" 
              type="month" 
            />

            <date-picker 
              v-else 
              v-model="filter.date_from" 
              :min="minDateFrom" 
              :max="maxDate" 
              :label="dateFromLabel" 
              class="mr-3" 
            />

            <date-picker 
              v-if="hasDateTo" 
              v-model="filter.date_to" 
              :disabled="!isDateToEditable"
              :min="minDateTo" 
              :max="maxDateTo" 
              label="Date To" 
              class="mr-3"
            />

            <autocomplete
              async
              clearable
              v-if="filter.sales_type !== config.invoiceTypes.franchisee"
              v-model="filter.retailer"
              label="Branch"
              sub-title="phone"
              key="retailer"
              :api-path="config.apis.searchRetailers"
            />
            
            <autocomplete
              v-model="filter.sales_type"
              label="Sale To"
              key="sales_type"
              :items="$options.types"
            />

            <autocomplete 
              async
              clearable
              v-if="filter.sales_type == config.invoiceTypes.customer"
              v-model="filter.customer"
              label="Customer Mobile"
              sub-title="title"
              search-key="mobile"
              key="customer-mobile"
              :api-path="config.apis.searchCustomers"
            />

            <autocomplete
              async
              clearable
              v-if="filter.sales_type == config.invoiceTypes.customer"
              v-model="filter.customer"
              label="Customer Name"
              sub-title="mobile"
              key="customer-name"
              :api-path="config.apis.searchCustomers"
            />

            <autocomplete
              async
              clearable
              v-if="filter.sales_type == config.invoiceTypes.franchisee"
              v-model="filter.franchisee"
              label="Franchisee"
              sub-title="phone"
              key="franchisee"
              :api-path="config.apis.searchRetailers"
            />

            <autocomplete
              async
              clearable
              v-model="filter.executive"
              label="Care of"
              sub-title="mobile"
              search-key="first_name"
              key="executive"
              :api-path="config.apis.searchExecutives"
            />

            <autocomplete
              async
              clearable
              v-model="filter.agent"
              label="LTP"
              sub-title="title"
              search-key="id"
              key="agent"
              :api-path="config.apis.searchAgents"
            />

            <autocomplete
              async
              clearable
              v-model="filter.item"
              label="Item Code"
              sub-title="title"
              search-key="item_code"
              key="itemByCode"
              :api-path="config.apis.searchItems"
            />

            <search-btn @click="loadReport" />

            <v-spacer></v-spacer>

          </v-card-title>
          
          <data-table
    		    :headers="headers"
    		    :items="processedItems"
            :loading="processing"
    		    :title="resultTitle"
    		    :sheet-name="sheetName"
    		    hide-actions
    		    download
    		  ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>
  
  import { reports } from '../../config/apis'
  import invoiceTypes from '../../config/invoiceTypes'

  import invoiceStatusMixin from '../../mixins/invoice-status'
  import reportMixin from '../../mixins/reports'

  import DataTable from '../../components/DataTable'
  import DatePickerDialog from '../../components/DatePickerDialog'

  export default {
    
    components: {
      'data-table': DataTable,
      'date-picker': DatePickerDialog,
    },

    mixins: [ 
    	reportMixin, 
    	invoiceStatusMixin,
    ],

    data () {
      return {
        invoiceTypes,
        title: "Item Wise Sales Report",
        reportsApiPath: reports.itemSales,
        filter: {
          period: "daily",
          date_from: this.today('YYYY-MM-DD'),
          date_to: '',
          year_month: '',
          sales_type: '',
          customer: null,
          franchisee: null,
          retailer: null,
          agent: null,
        },
        hasDateWiseReport: false,
      }
    },

    computed: {
    	
    	processedItems() {
    			
        return this.items.map(item => {
    			return {
    				item_code: item.item_code,
    				item_name: item.item_name,
    				item_count: item.item_count,
    				item_total: item.item_total,
    			}
    		})
    		
    	},

    },

    watch: {

      'filter.sales_type' (val) {
        
        this.filter.franchisee = ""
        this.filter.customer = ""

        if (val === invoiceTypes.franchisee) {
          this.filter.retailer = ""
        }
      },

      'filter.retailer' (val) {

        if (!val) {
          this.filter.retailer = ""
        }
      },

    },

    created () {

	    let types = [{
				id: "",
				title: "All"
			}]

		for (const [key, val] of Object.entries(invoiceTypes)) {
	        types.push({id: val, title: key})
	    }

	    this.$options.types = types

      // rate cannot be included as item rate can change at any time
	    this.$options.itemWiseHeaders = [
        { text: 'Item Code', value: 'item_code', sortable: false },
        { text: 'Item Name', value: 'item_name', sortable: false },
        { text: 'Sale Count', value: 'item_count', sortable: false, align: 'right' },
        { text: 'Total Amount', value: 'item_total', customFilter: 'roundValue', sortable: false, align: 'right' },
	    ]

    },

  }

</script>
